import { isClientEnv } from '@cdc-internal/fe-toolbox/utils/env'

import { logger } from '@/configs'
import { ResourceLink } from '@/types/resource'

const TOP_LEVEL = [
  'com',
  'cn',
  'dev',
  'fyi',
  'mobi',
  'tel',
  'asia',
  'net',
  'org',
  'name',
  'me',
  'tv',
  'info',
  'cc',
  'biz',
  'io',
  'finance',
]

// e.g. https://www.bitcoin.org > BITCOIN
export const parseDomain = (url: string | URL = '') => {
  let domain = ''
  try {
    if (typeof url === 'string') {
      url = new URL(url)
    }
    const domains = url.hostname.toLowerCase().split('.')
    for (let i = domains.length - 1; i > 0; i -= 1) {
      if (TOP_LEVEL.includes(domains[i])) {
        if (i) {
          domain = domains[i - 1]
        }
        break
      }
    }
    // Fallback to simple domain extraction if above parse failed
    if (!domain) {
      const hostname = url.hostname.toLowerCase()
      const parts = hostname.split('.')
      if (parts.length >= 2) {
        domain = parts[parts.length - 2]
      }
    }
  } catch (e) {
    if (isClientEnv) {
      logger.warn('Failed to parse URL domain', e)
    }
  }

  return domain
}

export const constructUrlDomain = (resourcesLinks: ResourceLink[]) =>
  resourcesLinks.forEach(resource => {
    if (resource.urls.length > 1) {
      const domainCount: Record<string, number> = {}
      resource.urlDomains = resource.urls.map(url => {
        let domain = parseDomain(url).toUpperCase()
        // Add count suffix behind the repeated domain name, e.g. DOMAIN 1, DOMAIN 2
        if (domain) {
          if (!domainCount[domain]) {
            domainCount[domain] = 0
          }
          domainCount[domain]++
          domain += ` ${domainCount[domain]}`
        }
        return {
          url,
          domain,
        }
      })
      // Remove the first count suffix if there have no repeated domain name, i.e. DOMAIN 1 => DOMAIN
      resource.urlDomains.forEach(urlDomain => {
        const domain = urlDomain.domain.replace(/\s.*/, '')
        if (domainCount[domain] === 1) {
          urlDomain.domain = domain
        }
      })
    }
  })
